import { render, staticRenderFns } from "./ChannelSuppliers.vue?vue&type=template&id=3d998938&"
import script from "./ChannelSuppliers.vue?vue&type=script&lang=ts&"
export * from "./ChannelSuppliers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelSuppliers.vue"
export default component.exports